/* What this user calls the seats. The names themselves live in core, where the sentences that
   use them are built; this keeps them with the settings that follow the account, under
   `seatNames`, and hands them to core when a page opens. */

import { setSeatNames, type SeatNames } from "@preflop/core";
import { loadSetting, saveSetting } from "./settings";

const SEAT_NAMES = "seatNames";

/** Before a page draws anything, and after the settings were brought into line with the
    profile: from here on every seat is called what the user calls it. */
export async function applySeatNames(): Promise<SeatNames> {
  return setSeatNames(await loadSetting<unknown>(SEAT_NAMES, null));
}

/** Only the seats that were renamed are kept: an empty object is the defaults. */
export async function saveSeatNames(names: SeatNames): Promise<SeatNames> {
  const applied = setSeatNames(names);
  await saveSetting(SEAT_NAMES, applied);
  return applied;
}
